// extracted by mini-css-extract-plugin
module.exports = {"button":"button-module--button--1Tg9s","buttonText":"button-module--buttonText--3ZgjF"};